import React from "react";

export default function PdfSectionImageTitle({ alt, imageUrl }) {
  return (
    <div className="pdf-report-section-title">
      <img alt={alt} src={imageUrl} />
    </div>
  );
}
